module.exports = __webpack_public_path__ + "img/luxury-4.ec862c23.png";